import { render, staticRenderFns } from "./floor.vue?vue&type=template&id=01f881aa&scoped=true&"
import script from "./floor.vue?vue&type=script&lang=js&"
export * from "./floor.vue?vue&type=script&lang=js&"
import style0 from "./floor.vue?vue&type=style&index=0&id=01f881aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f881aa",
  null
  
)

component.options.__file = "floor.vue"
export default component.exports